// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1BWf8","name":"ConsentHeader_name__1DT_H","birthday":"ConsentHeader_birthday__3Lxg3","skeleton":"ConsentHeader_skeleton__2UsAg"};